import * as yup from "yup";

export const IGNORE_ERROR = "IGNORE";

export const CALCULATION_LEASING_EDIT_FORM_SCHEMA = yup.object().shape({
  name: yup.string().required('Molimo Vas da unesite naziv'),
  leasingTypeId: yup.string().required('Molimo Vas da odaberete vrstu leasinga'),
  interestRate: yup.string().required('Molimo Vas da unesete kamatnu stopu'),
});

